import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./GoogleAnalytics.css";

declare global {
  interface Window { dataLayer: unknown[]; gtag: (...args: unknown[]) => void; }
}

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
const consentKey = "kujipy-analytics-consent";

const GoogleAnalytics = () => {
  const { pathname, search } = useLocation();
  const { t } = useTranslation();
  const [consent, setConsent] = useState(() => localStorage.getItem(consentKey));
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!measurementId || consent !== "accepted" || document.getElementById("kujipy-google-analytics")) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = (...args: unknown[]) => window.dataLayer.push(args);
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { send_page_view: false, anonymize_ip: true });
    const script = document.createElement("script");
    script.id = "kujipy-google-analytics";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.onload = () => setReady(true);
    document.head.appendChild(script);
  }, [consent]);

  useEffect(() => {
    if (!measurementId || !ready || consent !== "accepted" || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${pathname}${search}`
    });
  }, [pathname, search, ready, consent]);

  if (!measurementId || consent) return null;
  const choose = (value: "accepted" | "declined") => { localStorage.setItem(consentKey, value); setConsent(value); };
  return <aside className="analytics-consent" aria-label={t("analytics.title")}>
    <div><strong>{t("analytics.title")}</strong><p>{t("analytics.text")} <Link to="/privacy">{t("analytics.more")}</Link></p></div>
    <div className="analytics-consent__actions"><button type="button" className="button button--outline" onClick={() => choose("declined")}>{t("analytics.decline")}</button><button type="button" className="button button--primary" onClick={() => choose("accepted")}>{t("analytics.accept")}</button></div>
  </aside>;
};

export default GoogleAnalytics;
